<template>
  <v-card flat class="mt-5">
    <v-form ref="form2" v-model="valid2">
      <div class="px-3">
        <v-card-text class="pt-5">
          <v-row>
            <v-col cols="12" sm="8" md="6">
              <v-text-field
                :rules="reglas.usuario.usuario"
                label="Usuario"
                v-model="datos.usuario.usuario"
                required
                outlined
                dense
                hide-details="auto"
                class="mb-6"
              ></v-text-field>

              <!-- new password -->
              <v-text-field
                :rules="reglas.usuario.clave"
                v-model="datos.usuario.clave"
                :type="isNewPasswordVisible ? 'text' : 'password'"
                :append-icon="isNewPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
                label="Contraseña"
                outlined
                dense
                persistent-hint
                placeholder="*********"
                @click:append="isNewPasswordVisible = !isNewPasswordVisible"
              ></v-text-field>

              <!-- confirm password -->
              <v-text-field
                :rules="reglas.usuario.clave2"
                v-model="datos.usuario.clave2"
                :type="isCPasswordVisible ? 'text' : 'password'"
                :append-icon="isCPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
                label="Confirmar contraseña"
                outlined
                dense
                class="mt-3"
                placeholder="*********"
                @click:append="isCPasswordVisible = !isCPasswordVisible"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" md="6" class="d-none d-sm-flex justify-center position-relative">
              <v-img
                contain
                max-width="130"
                src="@/assets/images/3d-characters/pose-m-1.png"
                class="security-character"
              ></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </div>

      <!-- divider -->
      <v-divider></v-divider>

      <EmpleadoConfiguracionSeguridadTabs
        @AsignarPermisos="AsignarPermisos"
        :puestos="puestoFiltrador()"
        :roles="roles"
        :EmpleadoData="EmpleadoData"
        :arbol="arbol"
      >
      </EmpleadoConfiguracionSeguridadTabs>

      <v-divider></v-divider>
      <v-card-text>
        <v-btn color="primary" class="me-3 mt-3" @click="GuardarDatos()"> Guardar </v-btn>
        <v-btn color="secondary" @click="ResetFormulario()" outlined class="mt-3"> Cancelar </v-btn>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiKeyOutline, mdiLockOpenOutline, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { ref, watch, onBeforeMount } from '@vue/composition-api'
import store from '@/store'
import EmpleadoConfiguracionSeguridadTabs from './EmpleadoConfiguracionSeguridadTabs.vue'
import SeguridadService from '@/api/servicios/SeguridadService'
import PuestoService from '@/api/servicios/PuestoService'
import { async } from 'q'
export default {
  props: {
    EmpleadoData: Object,
  },
  components: { EmpleadoConfiguracionSeguridadTabs },
  setup(props, context) {
    const datos = ref(JSON.parse(JSON.stringify(props.EmpleadoData.empleado)))
    const form2 = ref(null)
    const valid2 = ref(true)
    const isCurrentPasswordVisible = ref(false)
    const isNewPasswordVisible = ref(false)
    const isCPasswordVisible = ref(false)
    const newPassword = ref('')
    const cPassword = ref('')
    const selection = ref(
      props.EmpleadoData.empleado.usuario.permisos ? props.EmpleadoData.empleado.usuario.permisos : [],
    )
    const roles = ref([])
    const puestos = ref([])
    const roles_puestos = ref([])
    const arbol = ref([])
    onBeforeMount(async () => {
      SeguridadService.obtenerRol({ id_usuario: store.state.user.id })
        .then(response => {
          console.log(response)
          if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
            roles.value = response.data.datos
          }
        })
        .catch(error => {
          console.log(error)
        })
      SeguridadService.arbolModulosListar({ id_usuario: store.state.user.id })
        .then(response => {
          console.log(response)
          if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
            arbol.value = response.data.datos
          }
        })
        .catch(error => {
          console.log(error)
        })

      PuestoService.obtenerPuestos({ ind_principal: true })
        .then(response => {
          console.log('obtenerPuestos', response.data.datos)
          if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
            puestos.value = response.data.datos
          }
        })
        .catch(error => {
          console.log(error)
        })
    })

    const existePuestoArbol = (_id_puesto) => {
      if (arbol.value.find(it => it.id_puesto == _id_puesto)) {
        return true
      } else {
        return false
      }
    }

    const puestoFiltrador =  () => {
      return puestos.value.filter(ite=>existePuestoArbol(ite.id))
    }

    watch(props, () => {
      console.log('permisos')
      datos.value = JSON.parse(JSON.stringify(props.EmpleadoData.empleado))
      //selection.value = ([...datos.value.usuario.permisos])
    })
    const AsignarPermisos = datos1 => {
      datos.value.usuario.permisos_rol_general = datos1.selectionRolGeneral
      datos.value.usuario.permisos_rol_puestos = datos1.selectionRolPuestos
      datos.value.usuario.permisos_usuario_general = datos1.selectionPermisosGeneral
      datos.value.usuario.permisos_usuario_puesto = datos1.selectionPermisosPuestos
    }
    const reglas = {
      usuario: {
        usuario: [
          v => !!v || 'Usuario es requerido',
          v => (v && v.length <= 20 && v.length >= 3) || 'Usuario debe ser valido',
        ],
        clave: [
          v => !!v || 'contraseñas es requerido',
          v => (v && v.length >= 4) || 'Contraseñas debe contener almenos 4 caracteres',
        ],
        clave2: [
          v => !!v || 'Confirmacion de contraseñas es requerido',
          v => (v && v == datos.value.usuario.clave) || 'Las contraseñas deben coincidir',
        ],
      },
    }
    const validarForm = () => {
      let val = form2.value?.validate()
      datos.value.usuario
      console.log(datos.value)
      const totalPermisp =
        datos.value.usuario.permisos_rol_general.length +
        datos.value.usuario.permisos_rol_puestos.length +
        datos.value.usuario.permisos_usuario_general.length +
        datos.value.usuario.permisos_usuario_puesto.length

      if (totalPermisp == 0) {
        val = false
      }
      return val
    }

    const FiltrarArboles = id_puesto => {
      const valor = store.state.user.arbol.filter(item => item.id_puesto == id_puesto)
      if (valor.length > 0) {
        return valor[0].arbol
      }
      return []
    }
    const ResetFormulario = () => {
      context.emit('ResetFormulario')
    }
    const resetValidation = () => {
      form2.value.resetValidation()
    }
    const GuardarDatos = () => {
      if (validarForm()) {
        console.log(datos.value)
        context.emit('GuardarDatos', { ...datos.value }, 2)
      } else {
        store.commit('setAlert', {
          message: 'Verifique que todos los datos estén completos',
          type: 'info',
        })
      }
    }

    return {
      isCurrentPasswordVisible,
      isNewPasswordVisible,
      isCPasswordVisible,
      newPassword,
      cPassword,
      icons: {
        mdiKeyOutline,
        mdiLockOpenOutline,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
      selectionType: 'leaf',
      selection,
      store,
      datos,
      reglas,
      form2,
      valid2,
      GuardarDatos,
      validarForm,
      FiltrarArboles,
      roles,
      puestos,
      AsignarPermisos,
      resetValidation,
      ResetFormulario,
      arbol,
      puestoFiltrador
    }
  },
}
</script>

<style lang="scss" scoped>
.two-factor-auth {
  max-width: 25rem;
}

.security-character {
  position: absolute;
  bottom: -0.5rem;
}
</style>
